module.exports = __webpack_public_path__ + "static/media/twitter.22c1e773.png";